import React from "react";
import "./menu.css";
import menuIcon from "./menu-icon.svg";
import braces from "./braces.svg";

window.addEventListener('scroll', () => {
  const scrolledHeight = window.scrollY;

  if(scrolledHeight < 10) {
    document.querySelector(".menubar").style.backgroundColor = "rgba(0, 0, 0, 0.3)";
  }
  else {
    document.querySelector(".menubar").style.backgroundColor = "rgba(0, 0, 0, 0.7)";
  }
});

const Menubar = () => {
  const menuInfo = {
    logo: "Portfoilo",
  };

  const listElements = [
    "Home",
    "Introduction",
    "Work",
    "Blog",
    "Testimonials",
    "Contact",
  ];

  const toggleMenu = () => {
    document.querySelector(".navbar").classList.toggle("toggledBar");
  };

  return (
    <nav className="menubar">
      <ul className="menulist">
        <li className="logo">
          <img src={braces} alt="logo" /> {menuInfo.logo}
        </li>
      </ul>

      <ul className="navbar">
        {listElements.map((element, index) => {
          return (
            <li className="navbar-item" key={index}>
              <a href={`#${element.toLowerCase()}`} onClick={() => {toggleMenu()}} >{element}</a>
            </li>
          );
        })}
      </ul>

      <ul
        className="navbar-btn"
        onClick={() => {
          toggleMenu()
        }}
      >
        <img className="navbar-icon" src={menuIcon} alt="menu=icon" />
      </ul>
    </nav>
  );
};

export default Menubar;
